import * as api from '@pointOfSale/api';

import { PredictionPeriod } from '../models';
import * as MutationTypes from '../mutationTypes';

export const predictionPeriodListRequest = async ({ commit, getters: { predictionPeriodList } }, pointOfSaleGuid) => {
  if (!predictionPeriodList || predictionPeriodList.length === 0) {
    const response = await api.predictionPeriodListRequest(pointOfSaleGuid);
    const predictionPeriodListRes = PredictionPeriod.toInstanceList(response.data.results);
    commit(MutationTypes.PREDICTION_PERIOD_LIST_SUCCESS, predictionPeriodListRes);
  }
  return predictionPeriodList;
};

export const predictionPeriodRequest = async ({ commit }, predictionPeriodGuid) => {
  const response = await api.predictionPeriodRequest(predictionPeriodGuid);
  const predictionPeriod = PredictionPeriod.toInstance(response.data);
  commit(MutationTypes.PREDICTION_PERIOD_SUCCESS, predictionPeriod);
  return predictionPeriod;
};

export const validatePeriodDemand = ({ commit }, periodGuid) => {
  commit(MutationTypes.VALIDATE_PERIOD_DEMAND, periodGuid);
};

export const validatePeriodPrices = ({ commit }, periodGuid) => {
  commit(MutationTypes.VALIDATE_PERIOD_PRICES, periodGuid);
};

export const validatePeriodEngineering = ({ commit }, periodGuid) => {
  commit(MutationTypes.VALIDATE_PERIOD_ENGINEERING, periodGuid);
};
